/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_No_LotInputs */

const vi_sales_return_no_lot = /** @type {(inputs: Sales_Return_No_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng này không có lô thật để nhập trả (hàng bán khi kho thiếu).`)
};

/**

* @param {Sales_Return_No_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_no_lot = /** @type {((inputs?: Sales_Return_No_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_No_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_no_lot(inputs)
});